import React from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useNavigate } from "react-router-dom";
import "./MenuCards.css";
import { TABLE_HEADERS } from "../../constants";
import { useTranslation } from "react-i18next";

const MenuCards = ({ label, path, onClick }) => {
    const navigate = useNavigate();
    const {t} = useTranslation();

    const handleNavigate = () => {
        if (typeof onClick === "function") {
            onClick();
            return;
        }
        navigate(path);
    };

    return (
        <div className="menu-card" onClick={handleNavigate}>
            <div className="card-body">
                <div className="card-title">
                    <h3>{label}</h3>
                </div>
                <div
                    className="header-divider"
                    style={{
                        height: "2px",
                        borderBottom: "2px solid var(--primary-main)",
                        marginTop: "0px",
                        width: "60px",
                    }}></div>
                <div className="card-more">
                    <h4>
                        {t('TABLE_HEADERS.MORE')} <ChevronRightIcon />
                    </h4>
                </div>
            </div>
        </div>
    );
};

export default MenuCards;
